import React, { FunctionComponent } from 'react'
import { Route, Routes } from 'react-router'

import { AppPath } from '../../../AppPath'
import { PolicyActivationCheck } from '../payment'
import { ProposalPath } from '../ProposalPath'

export const ProposalPolicyRoutes: FunctionComponent = () => (
  <Routes>
    <Route
      path={ProposalPath.PAYMENT + AppPath.WILDCARD}
      element={<PolicyActivationCheck />}
    />
    {/*
      We omit the catch-all ("*") route here to prevent a race condition during
      the transition from 'QUOTE' to 'POLICY' status. The parent router will handle
      non-matching paths.

      When the proposal binds, the status change triggers an immediate swap to
      ProposalPolicyRoutes while the URL is still at '/summary'. If we had a
      catch-all redirect here, it would trigger before the intended navigation
      to '/checkout' completes, resulting in a redirect to Home.
    */}
  </Routes>
)
